export default __webpack_public_path__ + "b27db6bc7c836f76d89391a09c8651ac.png";